import KeepAlive from "react-activation";
import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import {useCallback, useRef, useState} from "react";
import {message} from "antd";
import config from "./config";
import AddOrEditSpaceTypeManagement from "./addOrEditDom";
import {get} from "lodash-es";
import {delDealkingLifeSpace, fetchDealkingLifeSpaceList} from "@/services/talkOrder.ts";

const SpaceTypeManagement = () => {
  const listRef = useRef<any>()
  const [isVisible, setIsVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>();
  
  const fetchList = ({ current, pageSize, query }: any) => {
    // return new Promise(resolve => resolve({records: []}))
    return new Promise( (resolve, reject) => {
      try {
        fetchDealkingLifeSpaceList({current, pageSize, data: query}).then((res: any) => {
          const records = get(res, 'list')
          const total = get(res, 'count')
          resolve({records, total})
        })
      }catch (e) {
        reject({ success: false })
      }
    })
  };
  
  const onEdit = useCallback((record: Object) => {
    setIsVisible(true)
    setCurrentRecord(record)
  }, []);
  
  const onDel = (record: any) => {
    delDealkingLifeSpace(record.id).then((res: any) => {
      if (res?.status) {
        message.success('操作成功');
        listRef.current.reload()
      }
    })
  };
  
  const onAdd = useCallback(() => {
    setIsVisible(true)
  }, []);
  
  const extension = {
    request: { fetchList},
    events: { onAdd },
    // auth,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn confirm danger title='确认删除该条空间类型?' onClick={() => onDel(record)}>删除</SActionBtn>
          </STableActions>
        );
      },
    },
  };
  
  return (
    <div>
      <SLowcodeList config={{ ...config }} ref={listRef} {...extension} />
      {
        isVisible ?
          <AddOrEditSpaceTypeManagement
            record={currentRecord}
            onClose={() => {
              setCurrentRecord(undefined)
              setIsVisible(false)}}
            reload={() => listRef.current.reload()}
          /> : null
      }
    </div>
  )
}

export default (props: any) => {
  return (
    <KeepAlive name={props?.location?.pathname} id={'keep' + location.pathname}>
      <SpaceTypeManagement {...props} />
    </KeepAlive>
  );
};